import React from 'react';
import './PropertyHeader.css';
import locIcon from '../../assets/location.png';

const PropertyHeader = ({ title, location, price }) => {
  return (
    <div className="row-prop-header-p3">
      <div className="header-left">
        <h1>{title}</h1>
        <div className="loc-flex">
          <img src={locIcon} alt="location" />
          <span>{location}</span>
        </div>
      </div>
      <div className="header-right">
        <div className="price-wrapper">
          <span className="price-value ">{price}</span>
          <span className="currency-tag">EGP</span>
        </div>
      </div>
    </div>
  );
};

export default PropertyHeader;